/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import * as o from '../output/output_ast';

const CORE = '@angular/core';

export class Identifiers {
  /* Methods */
  static NEW_METHOD = 'factory';
  static TRANSFORM_METHOD = 'transform';
  static PATCH_DEPS = 'patchedDeps';

  /* Instructions */
  static namespaceHTML: o.ExternalReference = {name: 'ÉµÉµnamespaceHTML', moduleName: CORE};

  static namespaceMathML: o.ExternalReference = {name: 'ÉµÉµnamespaceMathML', moduleName: CORE};

  static namespaceSVG: o.ExternalReference = {name: 'ÉµÉµnamespaceSVG', moduleName: CORE};

  static element: o.ExternalReference = {name: 'ÉµÉµelement', moduleName: CORE};

  static elementStart: o.ExternalReference = {name: 'ÉµÉµelementStart', moduleName: CORE};

  static elementEnd: o.ExternalReference = {name: 'ÉµÉµelementEnd', moduleName: CORE};

  static select: o.ExternalReference = {name: 'ÉµÉµselect', moduleName: CORE};
  static advance: o.ExternalReference = {name: 'ÉµÉµadvance', moduleName: CORE};

  static updateSyntheticHostBinding:
      o.ExternalReference = {name: 'ÉµÉµupdateSyntheticHostBinding', moduleName: CORE};

  static componentHostSyntheticListener:
      o.ExternalReference = {name: 'ÉµÉµcomponentHostSyntheticListener', moduleName: CORE};

  static attribute: o.ExternalReference = {name: 'ÉµÉµattribute', moduleName: CORE};

  static attributeInterpolate1:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate1', moduleName: CORE};
  static attributeInterpolate2:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate2', moduleName: CORE};
  static attributeInterpolate3:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate3', moduleName: CORE};
  static attributeInterpolate4:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate4', moduleName: CORE};
  static attributeInterpolate5:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate5', moduleName: CORE};
  static attributeInterpolate6:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate6', moduleName: CORE};
  static attributeInterpolate7:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate7', moduleName: CORE};
  static attributeInterpolate8:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolate8', moduleName: CORE};
  static attributeInterpolateV:
      o.ExternalReference = {name: 'ÉµÉµattributeInterpolateV', moduleName: CORE};

  static classProp: o.ExternalReference = {name: 'ÉµÉµclassProp', moduleName: CORE};

  static elementContainerStart:
      o.ExternalReference = {name: 'ÉµÉµelementContainerStart', moduleName: CORE};

  static elementContainerEnd:
      o.ExternalReference = {name: 'ÉµÉµelementContainerEnd', moduleName: CORE};

  static elementContainer: o.ExternalReference = {name: 'ÉµÉµelementContainer', moduleName: CORE};

  static styleMap: o.ExternalReference = {name: 'ÉµÉµstyleMap', moduleName: CORE};

  static styleMapInterpolate1:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate1', moduleName: CORE};
  static styleMapInterpolate2:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate2', moduleName: CORE};
  static styleMapInterpolate3:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate3', moduleName: CORE};
  static styleMapInterpolate4:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate4', moduleName: CORE};
  static styleMapInterpolate5:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate5', moduleName: CORE};
  static styleMapInterpolate6:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate6', moduleName: CORE};
  static styleMapInterpolate7:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate7', moduleName: CORE};
  static styleMapInterpolate8:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolate8', moduleName: CORE};
  static styleMapInterpolateV:
      o.ExternalReference = {name: 'ÉµÉµstyleMapInterpolateV', moduleName: CORE};

  static classMap: o.ExternalReference = {name: 'ÉµÉµclassMap', moduleName: CORE};

  static classMapInterpolate1:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate1', moduleName: CORE};
  static classMapInterpolate2:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate2', moduleName: CORE};
  static classMapInterpolate3:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate3', moduleName: CORE};
  static classMapInterpolate4:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate4', moduleName: CORE};
  static classMapInterpolate5:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate5', moduleName: CORE};
  static classMapInterpolate6:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate6', moduleName: CORE};
  static classMapInterpolate7:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate7', moduleName: CORE};
  static classMapInterpolate8:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolate8', moduleName: CORE};
  static classMapInterpolateV:
      o.ExternalReference = {name: 'ÉµÉµclassMapInterpolateV', moduleName: CORE};

  static styleProp: o.ExternalReference = {name: 'ÉµÉµstyleProp', moduleName: CORE};

  static stylePropInterpolate1:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate1', moduleName: CORE};
  static stylePropInterpolate2:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate2', moduleName: CORE};
  static stylePropInterpolate3:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate3', moduleName: CORE};
  static stylePropInterpolate4:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate4', moduleName: CORE};
  static stylePropInterpolate5:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate5', moduleName: CORE};
  static stylePropInterpolate6:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate6', moduleName: CORE};
  static stylePropInterpolate7:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate7', moduleName: CORE};
  static stylePropInterpolate8:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolate8', moduleName: CORE};
  static stylePropInterpolateV:
      o.ExternalReference = {name: 'ÉµÉµstylePropInterpolateV', moduleName: CORE};

  static containerCreate: o.ExternalReference = {name: 'ÉµÉµcontainer', moduleName: CORE};

  static nextContext: o.ExternalReference = {name: 'ÉµÉµnextContext', moduleName: CORE};

  static templateCreate: o.ExternalReference = {name: 'ÉµÉµtemplate', moduleName: CORE};

  static text: o.ExternalReference = {name: 'ÉµÉµtext', moduleName: CORE};

  static enableBindings: o.ExternalReference = {name: 'ÉµÉµenableBindings', moduleName: CORE};

  static disableBindings: o.ExternalReference = {name: 'ÉµÉµdisableBindings', moduleName: CORE};

  static getCurrentView: o.ExternalReference = {name: 'ÉµÉµgetCurrentView', moduleName: CORE};

  static textInterpolate: o.ExternalReference = {name: 'ÉµÉµtextInterpolate', moduleName: CORE};
  static textInterpolate1: o.ExternalReference = {name: 'ÉµÉµtextInterpolate1', moduleName: CORE};
  static textInterpolate2: o.ExternalReference = {name: 'ÉµÉµtextInterpolate2', moduleName: CORE};
  static textInterpolate3: o.ExternalReference = {name: 'ÉµÉµtextInterpolate3', moduleName: CORE};
  static textInterpolate4: o.ExternalReference = {name: 'ÉµÉµtextInterpolate4', moduleName: CORE};
  static textInterpolate5: o.ExternalReference = {name: 'ÉµÉµtextInterpolate5', moduleName: CORE};
  static textInterpolate6: o.ExternalReference = {name: 'ÉµÉµtextInterpolate6', moduleName: CORE};
  static textInterpolate7: o.ExternalReference = {name: 'ÉµÉµtextInterpolate7', moduleName: CORE};
  static textInterpolate8: o.ExternalReference = {name: 'ÉµÉµtextInterpolate8', moduleName: CORE};
  static textInterpolateV: o.ExternalReference = {name: 'ÉµÉµtextInterpolateV', moduleName: CORE};

  static restoreView: o.ExternalReference = {name: 'ÉµÉµrestoreView', moduleName: CORE};

  static pureFunction0: o.ExternalReference = {name: 'ÉµÉµpureFunction0', moduleName: CORE};
  static pureFunction1: o.ExternalReference = {name: 'ÉµÉµpureFunction1', moduleName: CORE};
  static pureFunction2: o.ExternalReference = {name: 'ÉµÉµpureFunction2', moduleName: CORE};
  static pureFunction3: o.ExternalReference = {name: 'ÉµÉµpureFunction3', moduleName: CORE};
  static pureFunction4: o.ExternalReference = {name: 'ÉµÉµpureFunction4', moduleName: CORE};
  static pureFunction5: o.ExternalReference = {name: 'ÉµÉµpureFunction5', moduleName: CORE};
  static pureFunction6: o.ExternalReference = {name: 'ÉµÉµpureFunction6', moduleName: CORE};
  static pureFunction7: o.ExternalReference = {name: 'ÉµÉµpureFunction7', moduleName: CORE};
  static pureFunction8: o.ExternalReference = {name: 'ÉµÉµpureFunction8', moduleName: CORE};
  static pureFunctionV: o.ExternalReference = {name: 'ÉµÉµpureFunctionV', moduleName: CORE};

  static pipeBind1: o.ExternalReference = {name: 'ÉµÉµpipeBind1', moduleName: CORE};
  static pipeBind2: o.ExternalReference = {name: 'ÉµÉµpipeBind2', moduleName: CORE};
  static pipeBind3: o.ExternalReference = {name: 'ÉµÉµpipeBind3', moduleName: CORE};
  static pipeBind4: o.ExternalReference = {name: 'ÉµÉµpipeBind4', moduleName: CORE};
  static pipeBindV: o.ExternalReference = {name: 'ÉµÉµpipeBindV', moduleName: CORE};

  static hostProperty: o.ExternalReference = {name: 'ÉµÉµhostProperty', moduleName: CORE};

  static property: o.ExternalReference = {name: 'ÉµÉµproperty', moduleName: CORE};

  static propertyInterpolate:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate', moduleName: CORE};
  static propertyInterpolate1:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate1', moduleName: CORE};
  static propertyInterpolate2:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate2', moduleName: CORE};
  static propertyInterpolate3:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate3', moduleName: CORE};
  static propertyInterpolate4:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate4', moduleName: CORE};
  static propertyInterpolate5:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate5', moduleName: CORE};
  static propertyInterpolate6:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate6', moduleName: CORE};
  static propertyInterpolate7:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate7', moduleName: CORE};
  static propertyInterpolate8:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate8', moduleName: CORE};
  static propertyInterpolateV:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolateV', moduleName: CORE};

  static i18n: o.ExternalReference = {name: 'ÉµÉµi18n', moduleName: CORE};
  static i18nAttributes: o.ExternalReference = {name: 'ÉµÉµi18nAttributes', moduleName: CORE};
  static i18nExp: o.ExternalReference = {name: 'ÉµÉµi18nExp', moduleName: CORE};
  static i18nStart: o.ExternalReference = {name: 'ÉµÉµi18nStart', moduleName: CORE};
  static i18nEnd: o.ExternalReference = {name: 'ÉµÉµi18nEnd', moduleName: CORE};
  static i18nApply: o.ExternalReference = {name: 'ÉµÉµi18nApply', moduleName: CORE};
  static i18nPostprocess: o.ExternalReference = {name: 'ÉµÉµi18nPostprocess', moduleName: CORE};

  static pipe: o.ExternalReference = {name: 'ÉµÉµpipe', moduleName: CORE};

  static projection: o.ExternalReference = {name: 'ÉµÉµprojection', moduleName: CORE};
  static projectionDef: o.ExternalReference = {name: 'ÉµÉµprojectionDef', moduleName: CORE};

  static reference: o.ExternalReference = {name: 'ÉµÉµreference', moduleName: CORE};

  static inject: o.ExternalReference = {name: 'ÉµÉµinject', moduleName: CORE};

  static injectAttribute: o.ExternalReference = {name: 'ÉµÉµinjectAttribute', moduleName: CORE};

  static injectPipeChangeDetectorRef:
      o.ExternalReference = {name: 'ÉµÉµinjectPipeChangeDetectorRef', moduleName: CORE};

  static directiveInject: o.ExternalReference = {name: 'ÉµÉµdirectiveInject', moduleName: CORE};
  static invalidFactory: o.ExternalReference = {name: 'ÉµÉµinvalidFactory', moduleName: CORE};
  static invalidFactoryDep: o.ExternalReference = {name: 'ÉµÉµinvalidFactoryDep', moduleName: CORE};

  static templateRefExtractor:
      o.ExternalReference = {name: 'ÉµÉµtemplateRefExtractor', moduleName: CORE};

  static resolveWindow: o.ExternalReference = {name: 'ÉµÉµresolveWindow', moduleName: CORE};
  static resolveDocument: o.ExternalReference = {name: 'ÉµÉµresolveDocument', moduleName: CORE};
  static resolveBody: o.ExternalReference = {name: 'ÉµÉµresolveBody', moduleName: CORE};

  static defineComponent: o.ExternalReference = {name: 'ÉµÉµdefineComponent', moduleName: CORE};

  static setComponentScope: o.ExternalReference = {name: 'ÉµÉµsetComponentScope', moduleName: CORE};

  static ComponentDefWithMeta: o.ExternalReference = {
    name: 'ÉµÉµComponentDefWithMeta',
    moduleName: CORE,
  };

  static FactoryDef: o.ExternalReference = {
    name: 'ÉµÉµFactoryDef',
    moduleName: CORE,
  };

  static defineDirective: o.ExternalReference = {
    name: 'ÉµÉµdefineDirective',
    moduleName: CORE,
  };

  static DirectiveDefWithMeta: o.ExternalReference = {
    name: 'ÉµÉµDirectiveDefWithMeta',
    moduleName: CORE,
  };

  static InjectorDef: o.ExternalReference = {
    name: 'ÉµÉµInjectorDef',
    moduleName: CORE,
  };

  static defineInjector: o.ExternalReference = {
    name: 'ÉµÉµdefineInjector',
    moduleName: CORE,
  };

  static NgModuleDefWithMeta: o.ExternalReference = {
    name: 'ÉµÉµNgModuleDefWithMeta',
    moduleName: CORE,
  };

  static ModuleWithProviders: o.ExternalReference = {
    name: 'ModuleWithProviders',
    moduleName: CORE,
  };

  static defineNgModule: o.ExternalReference = {name: 'ÉµÉµdefineNgModule', moduleName: CORE};
  static setNgModuleScope: o.ExternalReference = {name: 'ÉµÉµsetNgModuleScope', moduleName: CORE};

  static PipeDefWithMeta: o.ExternalReference = {name: 'ÉµÉµPipeDefWithMeta', moduleName: CORE};

  static definePipe: o.ExternalReference = {name: 'ÉµÉµdefinePipe', moduleName: CORE};

  static queryRefresh: o.ExternalReference = {name: 'ÉµÉµqueryRefresh', moduleName: CORE};
  static viewQuery: o.ExternalReference = {name: 'ÉµÉµviewQuery', moduleName: CORE};
  static staticViewQuery: o.ExternalReference = {name: 'ÉµÉµstaticViewQuery', moduleName: CORE};
  static staticContentQuery: o.ExternalReference = {name: 'ÉµÉµstaticContentQuery', moduleName: CORE};
  static loadQuery: o.ExternalReference = {name: 'ÉµÉµloadQuery', moduleName: CORE};
  static contentQuery: o.ExternalReference = {name: 'ÉµÉµcontentQuery', moduleName: CORE};

  static NgOnChangesFeature: o.ExternalReference = {name: 'ÉµÉµNgOnChangesFeature', moduleName: CORE};

  static InheritDefinitionFeature:
      o.ExternalReference = {name: 'ÉµÉµInheritDefinitionFeature', moduleName: CORE};

  static CopyDefinitionFeature:
      o.ExternalReference = {name: 'ÉµÉµCopyDefinitionFeature', moduleName: CORE};

  static ProvidersFeature: o.ExternalReference = {name: 'ÉµÉµProvidersFeature', moduleName: CORE};

  static listener: o.ExternalReference = {name: 'ÉµÉµlistener', moduleName: CORE};

  static getFactoryOf: o.ExternalReference = {
    name: 'ÉµÉµgetFactoryOf',
    moduleName: CORE,
  };

  static getInheritedFactory: o.ExternalReference = {
    name: 'ÉµÉµgetInheritedFactory',
    moduleName: CORE,
  };

  // sanitization-related functions
  static sanitizeHtml: o.ExternalReference = {name: 'ÉµÉµsanitizeHtml', moduleName: CORE};
  static sanitizeStyle: o.ExternalReference = {name: 'ÉµÉµsanitizeStyle', moduleName: CORE};
  static defaultStyleSanitizer:
      o.ExternalReference = {name: 'ÉµÉµdefaultStyleSanitizer', moduleName: CORE};
  static sanitizeResourceUrl:
      o.ExternalReference = {name: 'ÉµÉµsanitizeResourceUrl', moduleName: CORE};
  static sanitizeScript: o.ExternalReference = {name: 'ÉµÉµsanitizeScript', moduleName: CORE};
  static sanitizeUrl: o.ExternalReference = {name: 'ÉµÉµsanitizeUrl', moduleName: CORE};
  static sanitizeUrlOrResourceUrl:
      o.ExternalReference = {name: 'ÉµÉµsanitizeUrlOrResourceUrl', moduleName: CORE};
}
